

setTimeout(function() {
  $(".hp-news .news-wrapper").append('<a class="btn btn-primary" href="/blog/">Všechny články</a>');
}, 300);
